module.exports = __webpack_public_path__ + "static/media/team-spirit.192b898e.svg";